const style = {
  root: {
    // color: 'rgba(0,0,0,0.4) !important'
  },
}

export default style
